/**
 * Bank Statements Translations
 */

import { Translations } from '../shared/i18n';

export const bankStatementsTranslations: Translations = {
    tr: {
        bankStatementsTitle: 'Banka Ekstreleri',
        bankStatementsDescription: 'Banka ekstrelerinizi yükleyin ve yönetin',
        bankStatementsEmptyTitle: 'Henüz banka ekstresi yok',
        bankStatementsEmptyText: 'Banka ekstrelerinizi yükleyerek işlemlerinizi takip edin.',
        // Column labels
        colBankName: 'Banka',
        colAccountNumber: 'Hesap No',
        colStatementPeriod: 'Dönem',
        colOpeningBalance: 'Açılış Bakiye',
        colClosingBalance: 'Kapanış Bakiye',
        colTotalDebits: 'Toplam Giden',
        colTotalCredits: 'Toplam Gelen',
        colTransactionCount: 'İşlem Sayısı',
        // Field labels
        fieldBankName: 'Banka Adı',
        fieldAccountHolder: 'Hesap Sahibi',
        fieldAccountNumber: 'Hesap Numarası',
        fieldCardNumber: 'Kart Numarası',
        fieldStatementDate: 'Ekstre Tarihi',
        fieldStatementPeriodStart: 'Dönem Başlangıcı',
        fieldStatementPeriodEnd: 'Dönem Bitişi',
        fieldOpeningBalance: 'Açılış Bakiyesi',
        fieldClosingBalance: 'Kapanış Bakiyesi',
        fieldTotalDebits: 'Toplam Giden',
        fieldTotalCredits: 'Toplam Gelen',
        fieldMinimumPayment: 'Asgari Ödeme',
        fieldDueDate: 'Son Ödeme Tarihi',
        // Section titles
        sectionStatementInfo: 'Ekstre Bilgileri',
        sectionBalance: 'Bakiye',
        sectionTransactions: 'İşlemler',
        // Transaction table
        txDate: 'Tarih',
        txDescription: 'Açıklama',
        txDebit: 'Giden',
        txCredit: 'Gelen',
        txAmount: 'Tutar',
        txBalance: 'Bakiye',
        txTotal: 'Toplam',
        txStatus: 'Durum',
        // Format settings
        sectionFormatSettings: 'Format Ayarları',
        formatDateLabel: 'Tarih Formatı',
        formatDateDesc: 'Tarihler yanlış okunduysa düzeltin. Örneğin 01.02 yerine 02.01 olmalıysa.',
        formatCurrencyLabel: 'Para Birimi',
        formatCurrencyDesc: 'Para birimi yanlış okunduysa doğru olanı seçin.',
        sectionStatementDetails: 'Ekstre Detayları',
        // Actions
        uploadStatement: 'Ekstre Yükle',
        noTransactions: 'Bu ekstrede işlem bulunamadı.',
        searchTransactionsPlaceholder: 'İşlemlerde ara...',
        backToStatements: 'Ekstrelere Dön',
        backToTransactions: 'İşlemlere Dön',
        backToReconciliation: 'Eşleştirmeye Dön',
        viewStatement: 'Ekstreyi Görüntüle',
        viewButton: 'Göster',
        statementDetailTitle: 'Ekstre Detayı',
        fetchBankStatementsError: 'Banka ekstreleri alınamadı',
        errorConnecting: 'Sunucuya bağlanırken hata oluştu',
        // Duplicate detection
        duplicateBannerTitle: '{count} işlem başka bir ekstrede de görünüyor',
        duplicateBannerOverlap: 'Kesişim dönemi: {start}. {end}',
        duplicateKeepCopy: 'Bu kopyayı tut',
        duplicateBadge: 'Kopya',
        markAsDuplicate: 'Kopya olarak işaretle',
        unmarkDuplicate: 'Kopyayı Kaldır',
        excludedBadge: 'Kopya',
        deleteTransaction: 'İşlemi sil',
        deletedTransactions: 'Silinen işlemler',
        restoreTransaction: 'Geri yükle',
        restoreTransactionConfirm: 'Bu işlem geri yüklenecek. Önceki eşleştirmesi geri gelmez, yeniden eşleştirme yapmanız gerekir.',
        deleteTransactionConfirm: 'Seçili işlemler silinecek.',
        deleteMatchedWarning: 'Bu işlemler şu belgelerle eşleştirilmiş: {docs}. Eşleştirmeler kaldırılacaktır.',
        deleteRestoreHint: 'Silinen işlemleri ekstre detayından geri alabilirsiniz.',
        duplicateMatchWarning: 'Bu işlem zaten bir belgeyle eşleştirilmiş. Kopya olarak işaretlerseniz eşleştirme kaldırılacak. Bu işlem geri alınamaz.',
        duplicateMatchConfirm: 'Devam et',
        // View toggle
        viewStatements: 'Ekstreler',
        viewTransactions: 'İşlemler',
        filterStatements: 'Ekstre filtresi',
        selectAll: 'Tümünü seç',
        txFilename: 'Dosya',

        // Export data labels
        exportDate: 'Tarih',
        exportDescription: 'Aciklama',
        exportDebit: 'Borc',
        exportCredit: 'Alacak',
        exportBalance: 'Bakiye',
        exportCurrency: 'Para Birimi',
        exportStatement: 'Ekstre',
        exportPeriod: 'Donem',
        exportTransactionCount: 'Islem Sayisi',
        exportTotalDebit: 'Toplam Borc',
        exportTotalCredit: 'Toplam Alacak',
        exportNet: 'Net',
        exportSummarySheet: 'Ozet',
        exportNoData: 'Secilen tarih araliginda islem bulunamadi.',
        exportFilenamePrefix: 'Banka_Ekstre_',
        exportMonths: 'Ocak,Subat,Mart,Nisan,Mayis,Haziran,Temmuz,Agustos,Eylul,Ekim,Kasim,Aralik',
    },
    en: {
        bankStatementsTitle: 'Bank Statements',
        bankStatementsDescription: 'Upload and manage your bank statements',
        bankStatementsEmptyTitle: 'No bank statements yet',
        bankStatementsEmptyText: 'Upload your bank statements to track your transactions.',
        // Column labels
        colBankName: 'Bank',
        colAccountNumber: 'Account No',
        colStatementPeriod: 'Period',
        colOpeningBalance: 'Opening Balance',
        colClosingBalance: 'Closing Balance',
        colTotalDebits: 'Total Outgoing',
        colTotalCredits: 'Total Incoming',
        colTransactionCount: 'Transactions',
        // Field labels
        fieldBankName: 'Bank Name',
        fieldAccountHolder: 'Account Holder',
        fieldAccountNumber: 'Account Number',
        fieldCardNumber: 'Card Number',
        fieldStatementDate: 'Statement Date',
        fieldStatementPeriodStart: 'Period Start',
        fieldStatementPeriodEnd: 'Period End',
        fieldOpeningBalance: 'Opening Balance',
        fieldClosingBalance: 'Closing Balance',
        fieldTotalDebits: 'Total Outgoing',
        fieldTotalCredits: 'Total Incoming',
        fieldMinimumPayment: 'Minimum Payment',
        fieldDueDate: 'Due Date',
        // Section titles
        sectionStatementInfo: 'Statement Information',
        sectionBalance: 'Balance',
        sectionTransactions: 'Transactions',
        // Transaction table
        txDate: 'Date',
        txDescription: 'Description',
        txDebit: 'Outgoing',
        txCredit: 'Incoming',
        txAmount: 'Amount',
        txBalance: 'Balance',
        txTotal: 'Total',
        txStatus: 'Status',
        // Format settings
        sectionFormatSettings: 'Format Settings',
        formatDateLabel: 'Date Format',
        formatDateDesc: 'Fix if dates were read incorrectly. For example, if 01.02 should be 02.01.',
        formatCurrencyLabel: 'Currency',
        formatCurrencyDesc: 'Change the currency if it was read incorrectly.',
        sectionStatementDetails: 'Statement Details',
        // Actions
        uploadStatement: 'Upload Statement',
        noTransactions: 'No transactions found in this statement.',
        searchTransactionsPlaceholder: 'Search transactions...',
        backToStatements: 'Back to Statements',
        backToTransactions: 'Back to Transactions',
        backToReconciliation: 'Back to Reconciliation',
        viewStatement: 'View Statement',
        viewButton: 'View',
        statementDetailTitle: 'Statement Detail',
        fetchBankStatementsError: 'Failed to fetch bank statements',
        errorConnecting: 'Error connecting to server',
        // Duplicate detection
        duplicateBannerTitle: '{count} transactions also appear in another statement',
        duplicateBannerOverlap: 'Overlap period: {start}. {end}',
        duplicateKeepCopy: 'Keep this copy',
        duplicateBadge: 'Duplicate',
        markAsDuplicate: 'Mark as duplicate',
        unmarkDuplicate: 'Remove Duplicate',
        excludedBadge: 'Duplicate',
        deleteTransaction: 'Delete transaction',
        deletedTransactions: 'Deleted transactions',
        restoreTransaction: 'Restore',
        restoreTransactionConfirm: 'This transaction will be restored. Previous matches will not be recovered. you will need to re-match.',
        deleteTransactionConfirm: 'Selected transactions will be deleted.',
        deleteMatchedWarning: 'These transactions are matched with: {docs}. The matches will be removed.',
        deleteRestoreHint: 'You can restore deleted transactions from the statement detail page.',
        duplicateMatchWarning: 'This transaction is already matched with a document. Marking as duplicate will remove the match. This cannot be undone.',
        duplicateMatchConfirm: 'Continue',
        // View toggle
        viewStatements: 'Statements',
        viewTransactions: 'Transactions',
        filterStatements: 'Filter statements',
        selectAll: 'Select all',
        txFilename: 'File',

        // Export data labels
        exportDate: 'Date',
        exportDescription: 'Description',
        exportDebit: 'Debit',
        exportCredit: 'Credit',
        exportBalance: 'Balance',
        exportCurrency: 'Currency',
        exportStatement: 'Statement',
        exportPeriod: 'Period',
        exportTransactionCount: 'Transaction Count',
        exportTotalDebit: 'Total Debit',
        exportTotalCredit: 'Total Credit',
        exportNet: 'Net',
        exportSummarySheet: 'Summary',
        exportNoData: 'No transactions found in the selected date range.',
        exportFilenamePrefix: 'Bank_Statement_',
        exportMonths: 'January,February,March,April,May,June,July,August,September,October,November,December',
    },
    de: {
        bankStatementsTitle: 'Kontoauszüge',
        bankStatementsDescription: 'Laden Sie Ihre Kontoauszüge hoch und verwalten Sie diese',
        bankStatementsEmptyTitle: 'Noch keine Kontoauszüge vorhanden',
        bankStatementsEmptyText: 'Laden Sie Ihre Kontoauszüge hoch, um Ihre Transaktionen zu verfolgen.',
        // Column labels
        colBankName: 'Bank',
        colAccountNumber: 'Kontonr.',
        colStatementPeriod: 'Zeitraum',
        colOpeningBalance: 'Anfangssaldo',
        colClosingBalance: 'Endsaldo',
        colTotalDebits: 'Gesamt Ausgang',
        colTotalCredits: 'Gesamt Eingang',
        colTransactionCount: 'Transaktionen',
        // Field labels
        fieldBankName: 'Bankname',
        fieldAccountHolder: 'Kontoinhaber',
        fieldAccountNumber: 'Kontonummer',
        fieldCardNumber: 'Kartennummer',
        fieldStatementDate: 'Auszugsdatum',
        fieldStatementPeriodStart: 'Zeitraum Beginn',
        fieldStatementPeriodEnd: 'Zeitraum Ende',
        fieldOpeningBalance: 'Anfangssaldo',
        fieldClosingBalance: 'Endsaldo',
        fieldTotalDebits: 'Gesamt Ausgang',
        fieldTotalCredits: 'Gesamt Eingang',
        fieldMinimumPayment: 'Mindestzahlung',
        fieldDueDate: 'Fälligkeitsdatum',
        // Section titles
        sectionStatementInfo: 'Auszugsinformationen',
        sectionBalance: 'Saldo',
        sectionTransactions: 'Transaktionen',
        // Transaction table
        txDate: 'Datum',
        txDescription: 'Beschreibung',
        txDebit: 'Ausgang',
        txCredit: 'Eingang',
        txAmount: 'Betrag',
        txBalance: 'Saldo',
        txTotal: 'Gesamt',
        txStatus: 'Status',
        // Format settings
        sectionFormatSettings: 'Formateinstellungen',
        formatDateLabel: 'Datumsformat',
        formatDateDesc: 'Korrigieren Sie, falls Datumsangaben falsch gelesen wurden. Z.B. wenn 01.02 eigentlich 02.01 sein sollte.',
        formatCurrencyLabel: 'Währung',
        formatCurrencyDesc: 'Ändern Sie die Währung, falls sie falsch erkannt wurde.',
        sectionStatementDetails: 'Auszugsdetails',
        // Actions
        uploadStatement: 'Auszug hochladen',
        noTransactions: 'Keine Transaktionen in diesem Auszug gefunden.',
        searchTransactionsPlaceholder: 'Transaktionen suchen...',
        backToStatements: 'Zurück zu Auszügen',
        backToReconciliation: 'Zurück zum Abgleich',
        statementDetailTitle: 'Auszugsdetail',
        fetchBankStatementsError: 'Kontoauszüge konnten nicht abgerufen werden',
        errorConnecting: 'Fehler bei der Verbindung zum Server',
        // Duplicate detection
        duplicateBannerTitle: '{count} Transaktionen erscheinen auch in einem anderen Kontoauszug',
        duplicateBannerOverlap: 'Überlappungszeitraum: {start}. {end}',
        duplicateKeepCopy: 'Diese Kopie behalten',
        duplicateBadge: 'Duplikat',
        markAsDuplicate: 'Als Duplikat markieren',
        unmarkDuplicate: 'Duplikat entfernen',
        excludedBadge: 'Duplikat',
        deleteTransaction: 'Transaktion löschen',
        deletedTransactions: 'Gelöschte Transaktionen',
        restoreTransaction: 'Wiederherstellen',
        restoreTransactionConfirm: 'Diese Transaktion wird wiederhergestellt. Vorherige Abgleiche werden nicht wiederhergestellt. Sie müssen erneut abgleichen.',
        deleteTransactionConfirm: 'Ausgewählte Transaktionen werden gelöscht.',
        deleteMatchedWarning: 'Diese Transaktionen sind abgeglichen mit: {docs}. Die Abgleiche werden entfernt.',
        deleteRestoreHint: 'Gelöschte Transaktionen können über die Kontoauszugsdetails wiederhergestellt werden.',
        duplicateMatchWarning: 'Diese Transaktion ist bereits mit einem Dokument abgeglichen. Wenn Sie sie als Duplikat markieren, wird der Abgleich entfernt. Dies kann nicht rückgängig gemacht werden.',
        duplicateMatchConfirm: 'Fortfahren',
        // View toggle
        viewStatements: 'Kontoauszüge',
        viewTransactions: 'Transaktionen',
        filterStatements: 'Kontoauszüge filtern',
        selectAll: 'Alle auswählen',
        txFilename: 'Datei',

        // Export data labels
        exportDate: 'Datum',
        exportDescription: 'Beschreibung',
        exportDebit: 'Soll',
        exportCredit: 'Haben',
        exportBalance: 'Saldo',
        exportCurrency: 'W\u00e4hrung',
        exportStatement: 'Kontoauszug',
        exportPeriod: 'Zeitraum',
        exportTransactionCount: 'Transaktionsanzahl',
        exportTotalDebit: 'Gesamtsoll',
        exportTotalCredit: 'Gesamthaben',
        exportNet: 'Netto',
        exportSummarySheet: '\u00dcbersicht',
        exportNoData: 'Keine Transaktionen im ausgew\u00e4hlten Zeitraum gefunden.',
        exportFilenamePrefix: 'Kontoauszug_',
        exportMonths: 'Januar,Februar,M\u00e4rz,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
    },
};
